// Customer details form card.
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import type { CUSTOMER_FORM } from '../mockData.js';
import { WriteButton } from '../../_w2a_lower/liveWrite.js';

export interface CustomerDetailsFormProps {
  form: typeof CUSTOMER_FORM;
  values: typeof CUSTOMER_FORM;
  onChange: (next: typeof CUSTOMER_FORM) => void;
  dirty: boolean;
  onDiscard: () => void;
  onSave: () => void;
  /** W31: true on a real session; Save stays visible but inert. */
  liveWritesPaused?: boolean;
}

export function CustomerDetailsForm({
  form,
  values,
  onChange,
  dirty,
  onDiscard,
  onSave,
  liveWritesPaused = false,
}: CustomerDetailsFormProps): ReactNode {
  function field<K extends keyof typeof CUSTOMER_FORM>(key: K, value: string): void {
    onChange({ ...values, [key]: value });
  }
  return (
    <section className="card ca-card">
      <div className="ca-card-head">
        <div>
          <Icon id="people" />
          <h2>Customer details</h2>
        </div>
        <span>Customer {form.customerId}</span>
      </div>
      <form
        className="ca-body"
        id="ca-profile-form"
        onSubmit={event => {
          event.preventDefault();
          if (liveWritesPaused) return;
          onSave();
        }}
      >
        <div className="ca-fields">
          <label>
            First name
            <input
              id="ca-first"
              name="first"
              value={values.first}
              required
              autoComplete="off"
              onChange={event => field('first', event.target.value)}
            />
          </label>
          <label>
            Last name
            <input
              id="ca-last"
              name="last"
              value={values.last}
              required
              autoComplete="off"
              onChange={event => field('last', event.target.value)}
            />
          </label>
          <label>
            Email
            <input
              id="ca-email"
              name="email"
              type="email"
              value={values.email}
              autoComplete="off"
              onChange={event => field('email', event.target.value)}
            />
          </label>
          <label>
            Phone
            <input
              id="ca-phone"
              name="phone"
              type="tel"
              value={values.phone}
              autoComplete="off"
              onChange={event => field('phone', event.target.value)}
            />
          </label>
        </div>
        <div className="ca-form-bottom">
          <p>
            <Icon id="check" />
            Contact preferences and permissions stay unchanged.
          </p>
          <div>
            <button
              className="ca-secondary"
              type="button"
              id="ca-discard"
              disabled={!dirty}
              onClick={onDiscard}
            >
              Discard changes
            </button>
            <WriteButton
              paused={liveWritesPaused}
              className="ca-blue"
              type="submit"
              id="ca-save-profile"
              disabled={!dirty}
              actionLabel="Save changes"
            >
              Save changes
            </WriteButton>
          </div>
        </div>
      </form>
    </section>
  );
}
